<template>
  <el-dialog
    title="Smartz ID Card"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="700px"
    class="edit-group"
  >
    <div
      ref="print"
      id="print-box"
      class="text-center qr-code-wrapper"
      style="min-height: 860px; overflow: auto"
    >
      <div v-loading="loading">
        <div class="flex-start mb-20">
          <div class="text-left mr-20">
            <img
              :src="require('@/assets/image/smartz-logo-black.svg')"
              class="w-100"
            />
          </div>
          <span class="bold-font font-30 inline-block mt-10">{{
            $t('text.id_card')
          }}</span>
        </div>
        <el-table border size="mini" :data="patientList">
          <el-table-column label="ID" prop="UniqueId"> </el-table-column>
          <el-table-column :label="$t('text.name').toUpperCase()">
            <template slot-scope="scope">
              {{ scope.row.FirstName }} {{ scope.row.LastName }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('text.room').toUpperCase()"
            prop="RoomNumber"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="print()">{{
        $t('text.print')
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import printJS from 'print-js'
import html2canvas from 'html2canvas'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      patientList: [],
      maxNumberOfPatientsPerPage: 20
    }
  },
  methods: {
    openDialog(id) {
      this.dialogVisible = true
      this.getPatientList(id)
    },
    closeDialog() {
      this.patientList = []
      this.dialogVisible = false
    },
    getPatientList(id) {
      this.loading = true
      ApiService.GetPatientsForObservationToPrint(id)
        .then(response => {
          this.loading = false
          this.patientList = response.data.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    print() {
      // get dynamic width and height
      let factor = Math.ceil(
        this.patientList.length / this.maxNumberOfPatientsPerPage
      )
      let width = factor * 2.125
      let height = factor * 3.375

      // clone dom, since there may have scroll bar
      let targetDom = document.getElementById('print-box')
      let clonedNode = targetDom.cloneNode(true)
      clonedNode.setAttribute(
        'style',
        `width: ${targetDom.offsetWidth}px;height: ${targetDom.offsetHeight}px;`
      )
      document.body.appendChild(clonedNode)
      let options = {
        backgroundColor: null,
        dpi: 300,
        scale: 100,
        removeContainer: false
      }
      html2canvas(clonedNode, options).then(canvas => {
        const url = canvas.toDataURL()
        printJS({
          printable: url,
          type: 'image',
          scanStyles: false,
          style: `body { text-align: center } img {width: ${width}in; height: ${height}in}`
        })
        document.body.removeChild(clonedNode)
      })
    }
  }
}
</script>

<style lang="scss"></style>
